import { render, staticRenderFns } from "./IconLogo01.vue?vue&type=template&id=44532ffe"
import script from "./IconLogo01.vue?vue&type=script&lang=ts"
export * from "./IconLogo01.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports